/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React, { Fragment, useEffect, useState } from 'react'
import { Modal } from 'antd-mobile'
import { forEach, isNil, padStart } from 'lodash'
import uuid from 'uuid'
import {
  DIA_ADVERTISEMENT_IMAGE_DISPLAYABLE_VIEW_TYPE,
} from '@constants/index'
import { message } from 'antd'
import useRootStore from '@store/useRootStore'
import { GAME_BANNER_TYPE, GIFT_BOX_TYPE } from '@v2/constants/common'
import { IGiftBoxGameBanners } from '@protocol/component'
import dayjs from 'dayjs'
import { observer } from 'mobx-react'
// import AdvCasino from '@views/AdvCasino'
// icon
import { DiaIco, GmoneyIco } from '@shared/Icon/MoneyIcon'
// css
import styled, { Theme, ThemeProps } from '@themes/theme'
import { ModalBg } from '@styles/base.style'
import { Button, EventFooter } from '@styles/button.style'
import { delay, isShowDiaAdvertisementImage, updateDiaAdvertisementImageLastShowedAt } from '@utils/utils'
import { RewardWrap } from './index.style'
// img
import GiftBoxBeforeImg from '@assets/images/bg/gift-box/gift-box-img.png'
import GiftBoxTopRewardImg from '@assets/images/bg/gift-box/gift-box-reward-top.png'
import GiftRewardDiaImg from '@assets/images/bg/gift-box/gift-box-reward-dia.png'
import GiftRewardGmoneyImg from '@assets/images/bg/gift-box/gift-box-reward-gmoney.png'
import GiftRewardsImg from '@assets/images/bg/gift-box/gift-box-rewards.png'
import GiftBoxBottomRewardImg from '@assets/images/bg/gift-box/gift-box-reward-bottom.png'
import GiftBoxBackRewardImg from '@assets/images/bg/gift-box/gift-box-reward-back.png'
import GiftBoxBackEffectYellowImg from '@assets/images/bg/gift-box/gift-box-effect-yellow.png'
import GiftBoxBackEffectBlueImg from '@assets/images/bg/gift-box/gift-box-effect-blue.png'
import GiftBoxOpenedImg from '@assets/images/bg/gift-box-opend-img.png'
import GiftBoxTxtImg from '@assets/images/bg/gift-box/gift-box-dia-txt.png'
import GiftBoxRewardCommentImg from '@assets/images/bg/gift-box/gift-box-reward-comment-img.png'
import GiftBoxBtnImg from '@assets/images/btn/gift-box-btn.png'
import GiftBoxCloseBtnImg from '@assets/images/btn/gift-box-close-btn.png'
import { PROPERTY_ID } from 'adv-protocol/src/GameCommon'
import PopupUtils from '@utils/popup-utils'

const DivTag = styled.div``
const GiftModalWrap = styled.div`
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  width: auto;
  max-width: 350px;
  min-width: 240px;
  transform: translate(-50%, -50%);
`
const GiftBoxWrap = styled.span`
  z-index: 0;
  position: relative;
  width: 100%;
  height: auto;
`
const GiftBoxStyle = css`
  position: relative;
  display: block;
  width: auto;
  height: 319px;
  margin: 0 auto;
  transform: translate3d(0, 20px, 0);

  &.reward {
    height: 155px;
  }

  /* &.opened {
    height: 148px;
  } */
`
const TxtWrap = styled.div`
  position: relative;

  .gift-box-txt{
    width: 145px;
    margin-left: 50%;
    transform: translateY(-6px);
  }
`
const TxtStyle = (props: ThemeProps) => css`
  position: relative;
  font-size: ${props.theme.font.large};
  line-height: 1.8rem;
`
const ButtonStyle = (theme: Theme) => css`
  width: 158px;
  height: 42px;
  line-height: 3rem;
  color: ${theme.color.themeTxt};
  background: none;
  .gift-box-btn, .gift-box-close-btn{
    width: 158px;
  }

  &.timer {
    background-color: ${theme.color.btn};
  }
`
const ChildModalStyle = (theme: Theme) => css`
  position: relative;
  width: 58.5vw !important;
  height: 238px;

  .am-modal-content {
    background: ${theme.color.TP} !important;
    padding: 0 10px 0;
    overflow: visible;
  }

  .am-modal-body {
    overflow: visible;
  }
`
const ChildTxt = styled.p`
  ${TxtStyle};
  display: block;
  margin-bottom: 4px;
  color: ${props => props.theme.color.themeTxt};
  font-size: 15px;
`
const GmoneyStyle = styled.span`
  position: relative;
  display: inline-block;
  top: -5px;
  width: 14px;
  margin-left: 4px;
  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -60%);
  }
`
const BannerWrap = css`
  width: 100%;
  height: auto;
  margin-bottom: 9px;
  border-radius: 6px;
  overflow: hidden;

  .banner-img {
    width: 100%;
  }
`
const GiftBoxArea = styled.div`
  width: 100%;
  min-height: 323px;
  height: auto;

  margin-bottom: 36px;
`

let interval = null
let fetchGiftBoxTimeOut = null

const GiftBox: React.FC = () => {
  const { authStore, globalStore, componentStore, logStore, matchupStore/*, clubStore*/ } = useRootStore()
  // const { clubs } = clubStore
  const { visibleGiftbox } = globalStore
  const [visibleChildModal, setVisibleChildModal] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)

  const [nextOpenTime, setNextOpenTime] = useState('23:59:59')
  const { giftbox, openGiftbox, giftBoxGameBanner } = componentStore
  const { signedin, userInfo } = authStore

  const gMoneyIcon = (
    <GmoneyStyle className="gmoney">
      <GmoneyIco/>
    </GmoneyStyle>
  )
  const diaIcon = (
    <GmoneyStyle className="gmoney">
      <DiaIco/>
    </GmoneyStyle>
  )
  let GiftBoxCenterReward: JSX.Element
  let childTxtEle: JSX.Element

  if (openGiftbox && openGiftbox.giftboxDeterminedCurrencyType) {
    if (openGiftbox.giftboxDeterminedCurrencyType === PROPERTY_ID.DIA) {
      childTxtEle = (
        <ChildTxt>
          {openGiftbox ? openGiftbox.giftboxDesc : ''}
          {diaIcon} 획득
        </ChildTxt>
      )
      GiftBoxCenterReward = (<img src={GiftRewardDiaImg} alt="다이아 보상 이미지" className="gift-box-img reward center"/>)
    } else {
      childTxtEle = (
        <ChildTxt>
          {openGiftbox ? openGiftbox.giftboxDesc : ''}
          {gMoneyIcon} 획득
        </ChildTxt>
      )
      GiftBoxCenterReward = (<img src={GiftRewardGmoneyImg} alt="G머니 보상 이미지" className="gift-box-img reward center"/>)
    }
  } else {
    childTxtEle = (
      <Fragment>
        <ChildTxt>
          {openGiftbox ? openGiftbox.giftboxDesc : ''}
          {diaIcon} 획득
        </ChildTxt>
        <ChildTxt>
          {openGiftbox ? openGiftbox.giftboxDesc : ''}
          {gMoneyIcon} 획득
        </ChildTxt>
      </Fragment>
    )
    GiftBoxCenterReward = (<img src={GiftRewardsImg} alt="다이아와 G머니 보상 이미지" className="gift-box-img reward center"/>)
  }

  const GiftBoxBefore = <img src={GiftBoxBeforeImg} alt="닫혀있는 선물상자" css={GiftBoxStyle} className="gift-box-img"/>
  const GiftBoxTopReward = <img src={GiftBoxTopRewardImg} alt="보상이 담긴 상자" className="gift-box-img reward top"/>
  const GiftBoxBottomReward = <img src={GiftBoxBottomRewardImg} alt="보상이 담긴 상자" className="gift-box-img reward bottom"/>
  const GiftBoxBackReward = <img src={GiftBoxBackRewardImg} alt="보상이 담긴 상자" className="gift-box-img reward back"/>
  const GiftBoxBackYellowEffect = <img src={GiftBoxBackEffectYellowImg} alt="보상이 담긴 상자" className="gift-box-img reward effect"/>
  const GiftBoxBackBlueEffect = <img src={GiftBoxBackEffectBlueImg} alt="보상이 담긴 상자" className="gift-box-img reward effect"/>
  const GiftBoxOpened = <img src={GiftBoxOpenedImg} alt="열려있는 선물상자" css={GiftBoxStyle} className="gift-box-img opened"/>
  const GiftBoxTxt = <img src={GiftBoxTxtImg} alt="베팅에 사용됩니다." className="gift-box-txt"/>
  const GiftBoxRewardComment = <img src={GiftBoxRewardCommentImg} alt="선물상자는 24시간 뒤에 다시 나타납니다."
                                    className="gift-box-img reward comment"/>
  const GiftBoxButton = <img src={GiftBoxBtnImg} alt="무료충전 하기 버튼" className="gift-box-btn"/>
  const GiftBoxCloseButton = <img src={GiftBoxCloseBtnImg} alt="확인 버튼" className="gift-box-close-btn"/>

  const s = 1000
  const m = s * 60
  const h = m * 60
  const d = h * 24
  let timer = 0

  useEffect(() => {
    if (visibleGiftbox) {
      componentStore.fetchGiftBoxGameBanner()
    }
  }, [visibleGiftbox])

  const setNextOpenTimeFunc = (from, to) => {
    const diff = to - from - timer
    const seconds = Math.floor((diff % m) / s)
    const minutes = Math.floor((diff % h) / m)
    const hours = Math.floor((diff % d) / h)
    timer += s
    const arr = [
      padStart(hours.toString(), 2, '0'),
      padStart(minutes.toString(), 2, '0'),
      padStart(seconds.toString(), 2, '0'),
    ]
    setNextOpenTime(arr.join(':'))
  }

  const startInterval = (from: string | Date, to: string | Date) => {
    clearInterval(interval)
    setNextOpenTimeFunc(dayjs(from).valueOf(), dayjs(to).valueOf())
    interval = setInterval(() => {
      setNextOpenTimeFunc(dayjs(from).valueOf(), dayjs(to).valueOf())
    }, s)
  }

  const fetchGiftBox = async () => {
    clearTimeout(fetchGiftBoxTimeOut)
    fetchGiftBoxTimeOut = setTimeout(async () => {
      await componentStore.getGiftBox({})
      const nextOpenDate =
        componentStore.giftbox && !componentStore.giftbox.openEnabled
          ? componentStore.giftbox.nextOpenDate
          : new Date().toISOString()
      const now = new Date().toISOString()
      if (!componentStore.giftbox.openEnabled) {
        startInterval(now, nextOpenDate)
      }
    }, 500)
  }

  const onCloseModal = async (ignoreButtonLog = false) => {
    if (!ignoreButtonLog) {
      logStore.writeButtonLog({ pageId: 'g010', buttonId: '002' }).catch(console.error)
    }
    clearInterval(interval)
    globalStore.setVisibleGiftBox(false)
    await delay(100)
    setNextOpenTime(null)
  }

  const showChildModal = async () => {
    setIsDisabled(true)
    logStore.writeButtonLog({ pageId: 'g010', buttonId: '003' }).catch(console.error)
    await componentStore.fetchOpenGiftbox({ 'giftboxType': GIFT_BOX_TYPE.GIFT_BOX })
    if (componentStore.openGiftbox && componentStore.openGiftbox.giftboxId) {
      componentStore.setGiftbox(null)
      onCloseModal(true)
      setVisibleChildModal(true)
      await authStore.refreshSimpleUserInfo()
    } else {
      message.error('이미 획득하셨습니다.')
    }
    setIsDisabled(false)
  }

  const onClickAnchor = (banner: IGiftBoxGameBanners.giftBoxBanner) => {
    logStore.writeButtonLog({ pageId: 'g010', buttonId: '004' }).catch(console.error)
    const { type, clubId } = banner
    if (type === GAME_BANNER_TYPE.RECOMMEND_CLUB_IN_GIFT_BOX) {
      matchupStore.changeClubId(clubId)
      onCloseModal(true)
    } else if (type === GAME_BANNER_TYPE.ADVERTISEMENT_IN_GIFT_BOX) {
      PopupUtils.showEventGuideImgPopup()
    }
  }

  const onCloseChildModal = () => {
    if (isShowDiaAdvertisementImage(DIA_ADVERTISEMENT_IMAGE_DISPLAYABLE_VIEW_TYPE.GIFT_POPUP)) {
      updateDiaAdvertisementImageLastShowedAt(DIA_ADVERTISEMENT_IMAGE_DISPLAYABLE_VIEW_TYPE.GIFT_POPUP)
    }
    setVisibleChildModal(false)
  }

  if (signedin && visibleGiftbox && !giftbox) {
    fetchGiftBox()
  }

  let elem = null
  if (!giftbox) {
    elem = <Fragment/>
  } else if (giftbox.openEnabled === true) {
    elem = (
      <Fragment>
        <GiftBoxWrap>{GiftBoxBefore}</GiftBoxWrap>
        <Button secondary css={ButtonStyle} onClick={showChildModal} disabled={isDisabled}>
          {GiftBoxButton}
        </Button>
      </Fragment>
    )
  } else if (giftbox.openEnabled === false) {
    // 현재는 선물상자 획득 시 무료충전버튼이 출력되지 않아 아래의 코드역시 출력되지 않고있습니다.
    elem = (
      <Fragment>
        <GiftBoxWrap>{GiftBoxOpened}</GiftBoxWrap>
        <Button className="timer" css={ButtonStyle} onClick={() => onCloseModal()}>
          남은시간 {nextOpenTime}
        </Button>
      </Fragment>
    )
  }

  const recommendClubBannerElements = []
  const advertisementBannerElements = []
  if (giftBoxGameBanner) {
    forEach(giftBoxGameBanner.banners, banner => {
      // const club = find(clubs, clubInfo => clubInfo.id === banner?.clubId)
      // const clubName = club?.name
      const element = (
        <Fragment key={uuid.v4()}>
          <DivTag css={BannerWrap} className="cursor-pointer" onClick={() => {
            onClickAnchor(banner)
          }}>
            {banner.bannerImageUrl && (<img src={banner.bannerImageUrl} alt="선물상자 하단 배너" className="banner-img"/>)}
          </DivTag>
        </Fragment>
      )

      if (banner.type === GAME_BANNER_TYPE.RECOMMEND_CLUB_IN_GIFT_BOX) {
        recommendClubBannerElements.push(element)
      } else if (banner.type === GAME_BANNER_TYPE.ADVERTISEMENT_IN_GIFT_BOX) {
        advertisementBannerElements.push(element)
      }
    })
  }

  return (
    <Fragment>
      <Modal
        transparent
        visible={visibleGiftbox}
        maskClosable={false}
        onClose={() => onCloseModal()}
        className="event"
      >
        <GiftModalWrap>
          <GiftBoxArea className="gift-box-area">
            {elem}
          </GiftBoxArea>

          {!isNil(userInfo.isSpecificClubMember) && !userInfo.isSpecificClubMember && recommendClubBannerElements}
          {advertisementBannerElements}

          <div css={EventFooter}>
            <Button className="event-popup-btn-cls" onClick={() => onCloseModal()}>
              <span className="cls-txt">닫기</span>
              <span className="cls-ico">닫기</span>
            </Button>
          </div>
        </GiftModalWrap>
        <ModalBg onClick={() => onCloseModal()} className="gift-box clickable"/>
      </Modal>

      {/* 두번째 모달 (획득 아이템) */}
      <Modal
        transparent
        visible={visibleChildModal}
        maskClosable={false}
        onClose={onCloseChildModal}
        css={ChildModalStyle}
        className="event"
      >
        {/* {Event} */}
        <RewardWrap>
          <TxtWrap className="after">
            {GiftBoxTxt}
            {childTxtEle}

          </TxtWrap>

          <div className="reward-img">
            {(openGiftbox && openGiftbox.giftboxDeterminedCurrencyType)
            && openGiftbox.giftboxDeterminedCurrencyType === PROPERTY_ID.DIA ?
              <Fragment>{GiftBoxBackBlueEffect}</Fragment>
              :
              <Fragment>{GiftBoxBackYellowEffect}</Fragment>
            }
            {GiftBoxBackReward}
            {GiftBoxCenterReward}
            {GiftBoxBottomReward}
            {GiftBoxTopReward}
          </div>

          <Button secondary css={ButtonStyle} onClick={onCloseChildModal}>
            {GiftBoxCloseButton}
          </Button>
          <div className="reward-img-comment-wrap">
            {GiftBoxRewardComment}
          </div>
        </RewardWrap>

        <ModalBg onClick={onCloseChildModal} className="gift-box"/>
      </Modal>
    </Fragment>
  )
}

export default observer(GiftBox)
